import React from 'react';

export function ErrorPage({ 
  title = "Seite nicht verfügbar", 
  message = "Diese Domain ist derzeit nicht verfügbar.",
  subtitle = "Bitte wenden Sie sich an den Administrator für weitere Informationen.",
  errorCode = "503",
  errorType = "Service Unavailable",
  showBackButton = false,
  onBack = () => window.history.back()
}) {
  return (
    <div className="bg-white dark:bg-slate-900 min-h-screen flex items-center justify-center">
      <div className="text-center p-8 max-w-md mx-auto">
        <div className="mb-6">
          <div className="text-6xl mb-4">⚠️</div>
          <h1 className="text-2xl font-bold text-red-600 dark:text-red-400 mb-2">
            {title}
          </h1>
        </div>
        
        <div className="text-slate-600 dark:text-slate-400 mb-6">
          <p className="mb-2">
            {message}
          </p>
          <p className="text-sm">
            {subtitle}
          </p>
        </div>
        
        {showBackButton && (
          <div className="mb-6">
            <button
              onClick={onBack}
              className="inline-flex items-center px-4 py-2 bg-slate-600 hover:bg-slate-700 text-white rounded-lg transition-colors duration-200"
            >
              <svg className="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 19l-7-7m0 0l7-7m-7 7h18" />
              </svg>
              Zurück
            </button>
          </div>
        )}
        
        <div className="border-t border-slate-200 dark:border-slate-700 pt-4">
          <p className="text-xs text-slate-500 dark:text-slate-500">
            Error {errorCode} - {errorType}
          </p>
        </div>
      </div>
    </div>
  );
}
